<ng-template #rowActions let-user>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit(user)" [actionData]="user"></action-menu>
</ng-template>
<data-table 
    title="Users"
    searchLabel="Search Users"
    searchPlaceholder="Name, user #, or email"
    loadingMessage="Loading users..."
    emptyMessage="No users found."
    [rows]="users()"
    [columns]="columns"
    [actionsTemplate]="rowActions"
    [loading]="loading()"
    [showRefresh]="true"
    [searchEnabled]="true"
    [searchTerm]="searchTerm()"
    [paginationEnabled]="true"
    [pageNumber]="pageNumber()"
    [pageSize]="pageSize()"
    [totalCount]="totalCount()"
    [totalPages]="totalPages()"
    (refreshed)="refreshed.emit()"
    (searchChanged)="searchChanged.emit($event)"
    (pageChanged)="pageChanged.emit($event)" />